import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface DynamicState {
  [key: string]: any;
  loaders: { [key: string]: boolean };
  tab: { [key: string]: any } | string | number; // Adjusted to allow string or number
}

const initialState: DynamicState = {
  loaders: {},
  analysisLoader: {},
  tab: {},
  analysis: {},
  chartFilterData: {},
};
const dynamicDataSlice = createSlice({
  name: "dynamicData",
  initialState,
  reducers: {
    startLoading: (state, action: PayloadAction<string | number>) => {
      state.loaders[action.payload] = true; // Set loader for API ID
    },
    stopLoading: (state, action: PayloadAction<string | number>) => {
      state.loaders[action.payload] = false; // Stop loader for API ID
    },
    setDynamicData: (
      state,
      action: PayloadAction<{ id: number; data: any }>
    ) => {
      state[action.payload.id] = action.payload.data;
    },
    setDynamicAnalysisData: (
      state,
      action: PayloadAction<{ id: number; data: any }>
    ) => {
      state.analysis[action.payload.id] = action.payload.data;
    },
    setAiInsightsRemarks: (
      state,
      action: PayloadAction<{ id: number; data: any }>
    ) => {
      state.analysis[action.payload.id] = action.payload.data;
    },
    setRemarksList: (
      state,
      action: PayloadAction<{ id: number; data: any }>
    ) => {
      state.analysis[action.payload.id] = action.payload.data;
    },
    setChartFilterData: (state, action: PayloadAction<any>) => {
      state.chartFilterData = action.payload;
    },
    clearDynamicData: (state, action: PayloadAction<number>) => {
      delete state[action.payload];
      delete state.analysis[action.payload];
      delete state.loaders[action.payload];
      delete state.analysisLoader[action.payload];
    },
  },
});

export const {
  setDynamicData,
  clearDynamicData,
  startLoading,
  stopLoading,
  setDynamicAnalysisData,
  setAiInsightsRemarks,
  setRemarksList,
  setChartFilterData,
} = dynamicDataSlice.actions;
export default dynamicDataSlice.reducer;
